import { cloneDeep } from 'lodash';

export default productDetails => ({
    productDetails,

    trackProductView() {
        if (typeof gtag === 'function') {
            gtag('event', 'view_item', cloneDeep(this.productDetails));
        }
    }
});
